(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customerreviews"] && !Shopify.designMode) return;
  try {
    

(() => {
  const section = document.querySelector(
    '#{{ review_id }}'
  );

  if (!section || section.dataset.reviewsReady === 'true') {
    return;
  }

  section.dataset.reviewsReady = 'true';

  const modal = section.querySelector(
    '[data-review-modal]'
  );

  const openButton = section.querySelector(
    '[data-review-open]'
  );

  const closeButtons = section.querySelectorAll(
    '[data-review-close]'
  );

  const picker = section.querySelector(
    '[data-rating-picker]'
  );

  const ratingInput = section.querySelector(
    '[data-rating-input]'
  );

  const form = section.querySelector(
    '[data-review-form]'
  );

  const message = section.querySelector(
    '[data-form-message]'
  );

  function openModal() {
    modal.hidden = false;
    document.body.classList.add(
      'customer-reviews-modal-open'
    );

    const closeButton = section.querySelector(
      '.customer-reviews__close'
    );

    if (closeButton) {
      closeButton.focus();
    }
  }

  function closeModal() {
    modal.hidden = true;
    document.body.classList.remove(
      'customer-reviews-modal-open'
    );

    if (openButton) {
      openButton.focus();
    }
  }

  if (openButton) {
    openButton.addEventListener(
      'click',
      openModal
    );
  }

  closeButtons.forEach((button) => {
    button.addEventListener(
      'click',
      closeModal
    );
  });

  document.addEventListener('keydown', (event) => {
    if (
      event.key === 'Escape' &&
      !modal.hidden
    ) {
      closeModal();
    }
  });

  if (picker) {
    picker.addEventListener('click', (event) => {
      const button = event.target.closest(
        '[data-rating-value]'
      );

      if (!button) {
        return;
      }

      const selectedRating = Number(
        button.dataset.ratingValue
      );

      ratingInput.value = selectedRating;

      picker
        .querySelectorAll('[data-rating-value]')
        .forEach((star) => {
          star.classList.toggle(
            'is-selected',
            Number(star.dataset.ratingValue) <= selectedRating
          );

          star.textContent =
            Number(star.dataset.ratingValue) <= selectedRating
              ? '★'
              : '☆';
        });
    });
  }

  if (form) {
    form.addEventListener('submit', (event) => {
      event.preventDefault();

      if (!ratingInput.value) {
        return;
      }

      message.hidden = false;
      form.reset();

      picker
        .querySelectorAll('[data-rating-value]')
        .forEach((star) => {
          star.classList.remove('is-selected');
          star.textContent = '☆';
        });

      setTimeout(() => {
        message.hidden = true;
        closeModal();
      }, 2500);
    });
  }

  const sort = section.querySelector(
    '[data-review-sort]'
  );

  const list = section.querySelector(
    '[data-review-list]'
  );

  if (sort && list) {
    sort.addEventListener('change', () => {
      const reviews = [
        ...list.querySelectorAll('.customer-review')
      ];

      if (sort.value === 'highest') {
        reviews.sort(
          (a, b) =>
            Number(b.dataset.rating) -
            Number(a.dataset.rating)
        );
      }

      if (sort.value === 'lowest') {
        reviews.sort(
          (a, b) =>
            Number(a.dataset.rating) -
            Number(b.dataset.rating)
        );
      }

      reviews.forEach((review) => {
        list.appendChild(review);
      });
    });
  }
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();
})();
